import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import RnRLogo from '../components/public/RnRLogo';

export default function DatenschutzPage() {
  return (
    <div className="min-h-screen bg-bg-primary text-text-primary">
      <div className="max-w-3xl mx-auto px-6 py-16">
        <div className="mb-10 flex items-center justify-between">
          <Link to="/" className="inline-flex items-center gap-2 font-body text-text-muted text-sm hover:text-accent-red transition-colors">
            <ArrowLeft size={16} />
            Zurück zur Startseite
          </Link>
          <RnRLogo className="h-14" />
        </div>

        <h1 className="font-heading text-5xl md:text-6xl text-text-primary mb-4">DATENSCHUTZ</h1>
        <p className="font-body text-text-muted text-sm mb-12">Stand: Juni 2026</p>

        <div className="space-y-10 font-body text-text-muted leading-relaxed">

          <section>
            <h2 className="font-heading text-xl text-text-primary mb-4">1. VERANTWORTLICHE STELLE</h2>
            <p>
              Verantwortlich für die Datenverarbeitung auf dieser Website ist:
            </p>
            <div className="mt-3 pl-4 border-l-2 border-divider">
              <p>prOju – Projekt Offene Jugendarbeit</p>
              <p>Katholische Kirchengemeinde St. Peter und Paul</p>
              <p>Kirchstraße 18, 53557 Bad Hönningen</p>
              <p className="mt-2">Tel.: 02635 / 5355</p>
              <p>E-Mail: <a href="mailto:info@proju.org" className="text-accent-red hover:underline">info@proju.org</a></p>
            </div>
          </section>

          <section>
            <h2 className="font-heading text-xl text-text-primary mb-4">2. HOSTING & SERVER-LOGFILES</h2>
            <p>
              Diese Website wird auf Servern von Replit Inc. (USA) gehostet. Bei jedem Aufruf unserer
              Website werden automatisch Informationen in sogenannten Server-Logfiles gespeichert, die
              euer Browser automatisch übermittelt. Dies sind:
            </p>
            <ul className="mt-3 space-y-1 pl-5 list-disc">
              <li>Aufgerufene Seite / Datei</li>
              <li>Datum und Uhrzeit des Abrufs</li>
              <li>Übertragene Datenmenge</li>
              <li>Browsertyp und -version</li>
              <li>Betriebssystem</li>
              <li>Referrer-URL (zuvor besuchte Seite)</li>
              <li>IP-Adresse und anfragender Provider</li>
            </ul>
            <p className="mt-3">
              Diese Daten werden nicht mit anderen Datenquellen zusammengeführt. Rechtsgrundlage ist
              Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse am sicheren Betrieb der Website).
              Die Daten werden nach spätestens 7 Tagen automatisch gelöscht.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl text-text-primary mb-4">3. COOKIES & SESSION</h2>
            <p>
              Diese Website verwendet technisch notwendige Cookies. Ein Session-Cookie
              (<code className="text-text-primary bg-bg-secondary px-1 rounded text-xs">rnr_session</code>)
              wird für den passwortgeschützten Admin-Bereich gesetzt und automatisch beim Schließen des
              Browsers gelöscht. Ohne diesen Cookie ist der Admin-Bereich nicht zugänglich.
            </p>
            <p className="mt-3">
              Darüber hinaus wird ein Cookie für eure Cookie-Einwilligung gesetzt
              (<code className="text-text-primary bg-bg-secondary px-1 rounded text-xs">rnr_cookie_consent</code>),
              um diese Seite beim nächsten Besuch nicht erneut anzuzeigen. Dieser Cookie ist ebenfalls
              technisch notwendig und enthält keinerlei personenbezogene Daten.
            </p>
            <p className="mt-3">
              Es werden keine Tracking-, Analyse- oder Marketing-Cookies verwendet.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl text-text-primary mb-4">4. KONTAKTFORMULAR / BAND-BEWERBUNG</h2>
            <p>
              Wenn ihr euch als Band über unser Formular bewerbt, werden die von euch eingegebenen
              Daten (Bandname, Kontaktdaten, Musiklinks, Demo-Dateien) zur Bearbeitung eurer Bewerbung
              gespeichert. Die Daten werden ausschließlich für die Auswahl der Festivalacts verwendet
              und nicht an Dritte weitergegeben.
            </p>
            <p className="mt-3">
              Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (Vertragsanbahnung). Die Daten werden
              nach Abschluss des Auswahlverfahrens gelöscht, spätestens jedoch 6 Monate nach dem
              Festival.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl text-text-primary mb-4">5. NEWSLETTER</h2>
            <p>
              Wer sich für unseren Newsletter anmeldet, speichert dabei die angegebene E-Mail-Adresse.
              Die Anmeldung ist freiwillig. Ihr könnt euch jederzeit durch eine formlose E-Mail an{' '}
              <a href="mailto:info@proju.org" className="text-accent-red hover:underline">info@proju.org</a>{' '}
              abmelden.
            </p>
            <p className="mt-3">
              Rechtsgrundlage ist Art. 6 Abs. 1 lit. a DSGVO (Einwilligung). Die E-Mail-Adresse wird
              ausschließlich zum Versand von Informationen rund um das Rock'n'Rhein-Festival genutzt.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl text-text-primary mb-4">6. GOOGLE MAPS</h2>
            <p>
              Diese Website bindet Google Maps (Google Ireland Ltd., Gordon House, Barrow Street,
              Dublin 4, Irland) ein. Google Maps wird erst dann geladen, wenn ihr es durch Klick
              ausdrücklich aktiviert. Bis dahin wird kein Kontakt zu Google-Servern hergestellt.
            </p>
            <p className="mt-3">
              Mit der Aktivierung erklärt ihr euch mit der Übertragung eurer Daten (u. a. IP-Adresse)
              an Google einverstanden. Informationen zur Datenverarbeitung durch Google findet ihr
              unter{' '}
              <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-accent-red hover:underline">
                policies.google.com/privacy
              </a>.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl text-text-primary mb-4">7. SOCIAL MEDIA</h2>
            <p>
              Auf dieser Website befinden sich Links zu unseren Social-Media-Profilen (Instagram,
              Facebook). Diese Links werden erst durch euren Klick aktiv — es werden vorab keine Daten
              an Meta oder Instagram übertragen. Für die Datenverarbeitung auf den jeweiligen
              Plattformen sind deren Betreiber verantwortlich.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl text-text-primary mb-4">8. EURE RECHTE</h2>
            <p>Nach der DSGVO habt ihr folgende Rechte:</p>
            <ul className="mt-3 space-y-1 pl-5 list-disc">
              <li><strong className="text-text-primary">Auskunft</strong> (Art. 15 DSGVO) über eure gespeicherten Daten</li>
              <li><strong className="text-text-primary">Berichtigung</strong> (Art. 16 DSGVO) unrichtiger Daten</li>
              <li><strong className="text-text-primary">Löschung</strong> (Art. 17 DSGVO) eurer Daten</li>
              <li><strong className="text-text-primary">Einschränkung</strong> (Art. 18 DSGVO) der Verarbeitung</li>
              <li><strong className="text-text-primary">Widerspruch</strong> (Art. 21 DSGVO) gegen die Verarbeitung</li>
              <li><strong className="text-text-primary">Datenübertragbarkeit</strong> (Art. 20 DSGVO)</li>
            </ul>
            <p className="mt-3">
              Anfragen dazu richtet bitte an:{' '}
              <a href="mailto:info@proju.org" className="text-accent-red hover:underline">info@proju.org</a>
            </p>
            <p className="mt-3">
              Ihr habt außerdem das Recht, euch bei der zuständigen Datenschutzaufsichtsbehörde zu
              beschweren. Zuständig ist der Landesbeauftragte für den Datenschutz Rheinland-Pfalz.
            </p>
          </section>

        </div>

        <div className="mt-16 pt-8 border-t border-divider flex gap-6 text-xs font-body text-text-muted">
          <Link to="/impressum" className="hover:text-accent-red transition-colors">Impressum</Link>
          <Link to="/datenschutz" className="hover:text-accent-red transition-colors">Datenschutz</Link>
        </div>
      </div>
    </div>
  );
}
